import React from "react";

interface IButtonFilter {
  handleFilterClick: () => string | void;
  handelClearFilterClick: () => void;
  disabled?: boolean;
}

export default function Button({ handleFilterClick, handelClearFilterClick, disabled = false }: IButtonFilter) {
  return (
    <div className="btn-filter-hours-management box-row">
      <button className={`btn bg-secondary ${disabled && "disabled"}`} type="button" onClick={handelClearFilterClick} disabled={disabled}>
        LIMPAR
      </button>
      <button className={`btn bg-primary ${disabled && "disabled"}`} type="button" onClick={handleFilterClick} disabled={disabled}>
        FILTRAR
      </button>
    </div>
  );
}
